<div [formGroup]="form" class="detail-right-column">
   @if (showCards) {
   <ndt-card [title]="'General Information'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="generalInfoFields"></ng-container>
   </ndt-card>
   } @else {
   <mat-form-field class="flex-half">
      <mat-label>Extension Number</mat-label>
      <input
         matInput
         autocomplete="off"
         type="number"
         [value]="extension?.number"
         [formControl]="parentFormGroup.get('number')"
         required
         id="a548a982-17d2-4bee-9fa9-e2df166087e7"
      />
      @if (parentFormGroup.get('number')?.hasError('required')) {
      <mat-error> Number Field is Required. </mat-error>
      } @if (parentFormGroup.get('number')?.hasError('pattern')) {
      <mat-error> Invalid Number Format </mat-error>
      } @if (parentFormGroup.get('number')?.hasError('min') || parentFormGroup.get('number')?.hasError('max')) {
      <mat-error> Number must be between 100-99999. </mat-error>
      } @if (parentFormGroup.get('number')?.hasError('extensionAlreadyExists')) {
      <mat-error> Extension number already in use. </mat-error>
      }
   </mat-form-field>
   <mat-form-field class="flex-half">
      <mat-label>Name</mat-label>
      <input
         matInput
         autocomplete="off"
         type="text"
         [value]="extension?.name"
         [formControl]="parentFormGroup.get('name')"
         required
         id="31ebd3f9-980e-4a68-b05d-0d3d768c2d4c"
      />
      @if (parentFormGroup.get('name')?.hasError('required')) {
      <mat-error> Name Field is Required. </mat-error>
      } @if ( !parentFormGroup.get('name')?.hasError('required') && parentFormGroup.get('name')?.hasError('noContent') )
      {
      <mat-error> Name must contain characters. </mat-error>
      }
   </mat-form-field>
   <mat-form-field class="flex-half">
      <mat-label>Short Name</mat-label>
      <input
         matInput
         autocomplete="off"
         type="text"
         [value]="extension?.shortName"
         [formControl]="parentFormGroup.get('shortName')"
         id="881e3620-615e-4e70-98ff-455dfd8e6b4c"
      />
      @if (parentFormGroup.get('shortName')?.hasError('pattern')) {
      <mat-error> Short Name cannot be greater than 20 characters. </mat-error>
      }
   </mat-form-field>
   }
   <ng-template #generalInfoFields>
      <mat-form-field class="flex-half">
         <mat-label>Extension Number</mat-label>
         <input
            matInput
            autocomplete="off"
            type="number"
            [value]="extension?.number"
            [formControl]="parentFormGroup.get('number')"
            required
            id="a548a982-17d2-4bee-9fa9-e2df166087e7"
         />
         @if (parentFormGroup.get('number')?.hasError('required')) {
         <mat-error> Number Field is Required. </mat-error>
         } @if (parentFormGroup.get('number')?.hasError('pattern')) {
         <mat-error> Invalid Number Format </mat-error>
         } @if (parentFormGroup.get('number')?.hasError('min') || parentFormGroup.get('number')?.hasError('max')) {
         <mat-error> Number must be between 100-99999. </mat-error>
         } @if (parentFormGroup.get('number')?.hasError('extensionAlreadyExists')) {
         <mat-error> Extension number already in use. </mat-error>
         }
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>Name</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            [value]="extension?.name"
            [formControl]="parentFormGroup.get('name')"
            required
            id="31ebd3f9-980e-4a68-b05d-0d3d768c2d4c"
         />
         @if (parentFormGroup.get('name')?.hasError('required')) {
         <mat-error> Name Field is Required. </mat-error>
         } @if ( !parentFormGroup.get('name')?.hasError('required') &&
         parentFormGroup.get('name')?.hasError('noContent') ) {
         <mat-error> Name must contain characters. </mat-error>
         }
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>Short Name</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            [value]="extension?.shortName"
            [formControl]="parentFormGroup.get('shortName')"
            id="881e3620-615e-4e70-98ff-455dfd8e6b4c"
         />
         @if (parentFormGroup.get('shortName')?.hasError('pattern')) {
         <mat-error> Short Name cannot be greater than 20 characters. </mat-error>
         }
      </mat-form-field>
   </ng-template>

   @if (showCards) {
   <ndt-card [title]="'Notes'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="noteFields"></ng-container>
   </ndt-card>
   }
   <ng-template #noteFields>
      @if (isSystemUser) {
      <mat-form-field class="flex-half">
         <mat-label>Admin Notes</mat-label>
         <textarea
            matInput
            [formControl]="parentFormGroup.get('adminNotes')"
            id="extension-phone-dnd-status"
         ></textarea>
      </mat-form-field>
      }
      <mat-form-field [ngClass]="{ 'flex-full': !isSystemUser, 'flex-half': isSystemUser }">
         <mat-label>Extension Notes</mat-label>
         <textarea
            matInput
            [formControl]="parentFormGroup.get('extensionNotes')"
            id="extension-phone-dnd-status"
            [readonly]="isSystemUser"
         ></textarea>
      </mat-form-field>
   </ng-template>

   @if (showCards) {
   <ndt-card [title]="'Settings'" class="detail-card">
      <ng-container *ngTemplateOutlet="settingsFields"></ng-container>
   </ndt-card>
   } @else {
   <mat-form-field class="flex-half field-padding-right">
      <mat-label>Default Phone Number</mat-label>
      <input
         [lcsSingleSelect]="phoneNumberSelect"
         [accountId]="accountId"
         ndtPhoneNumberSelect
         autocomplete="off"
         type="text"
         formControlName="defaultPhoneNumber"
         id="extension-fax-default-phone-number"
      />
      <ndt-phone-number-select
         #phoneNumberSelect
         [onlyAllowOutboundCallsNumbers]="true"
         [includeFax]="true"
         [isIncludeEmptyOption]="true"
      ></ndt-phone-number-select>
   </mat-form-field>
   <mat-form-field class="flex-half">
      <mat-label>Email Address</mat-label>
      <input
         matInput
         autocomplete="off"
         type="text"
         [value]="extensionFax?.emailAddress"
         formControlName="emailAddress"
         required
      />
      @if (form.get('emailAddress')?.hasError('required')) {
      <mat-error> Email Address Field is Required. </mat-error>
      } @if (form.get('emailAddress')?.hasError('pattern')) {
      <mat-error> Invalid Email Address </mat-error>
      }
   </mat-form-field>
   @if (accountId) {
   <mat-form-field class="flex-half">
      <mat-label>Location</mat-label>
      <input
         autocomplete="off"
         type="text"
         [lcsSingleSelect]="locationSelect"
         ndtLocationSelect
         [accountId]="accountId"
         [formControl]="parentFormGroup.get('location')"
         id="location"
      />
      <ndt-location-select #locationSelect isIncludeEmptyOption="true"></ndt-location-select>
   </mat-form-field>
   }
   <mat-form-field class="flex-half">
      <mat-label>Time Zone</mat-label>
      <input
         class="empty-option-placeholder"
         [lcsSingleSelect]="timeZoneSelect"
         ndtTimeZoneSelect
         autocomplete="off"
         type="text"
         [formControl]="parentFormGroup.get('timeZone')"
         id="extension-phone-time-zone"
         [placeholder]="
            'Use Location/Account Time Zone - (' +
            (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
            ')'
         "
      />
      <ndt-time-zone-select
         #timeZoneSelect
         isIncludeEmptyOption="true"
         [overrideEmptyOption]="
            'Use Location/Account Time Zone - (' +
            (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
            ')'
         "
      ></ndt-time-zone-select>
   </mat-form-field>
   @if (extensionPrivileges) {
   <ndt-fax-emails
      [form]="form"
      class="flex-full"
      formControlName="faxEmailAddresses"
      [extensionId]="extensionFax?.extension?.extensionId"
      [extensionPrivileges]="extensionPrivileges"
      [isOnAdd]="true"
   >
      ></ndt-fax-emails
   >
   } }
   <ng-template #settingsFields>
      <mat-form-field class="flex-half field-padding-right">
         <mat-label>Default Phone Number</mat-label>
         <input
            [lcsSingleSelect]="phoneNumberSelect"
            [accountId]="accountId"
            ndtPhoneNumberSelect
            autocomplete="off"
            type="text"
            formControlName="defaultPhoneNumber"
            id="extension-fax-default-phone-number"
         />
         <ndt-phone-number-select
            #phoneNumberSelect
            [onlyAllowOutboundCallsNumbers]="true"
            [includeFax]="true"
            [isIncludeEmptyOption]="true"
         ></ndt-phone-number-select>
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>Email Address</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            [value]="extensionFax?.emailAddress"
            formControlName="emailAddress"
            required
         />
         @if (form.get('emailAddress')?.hasError('required')) {
         <mat-error> Email Address Field is Required. </mat-error>
         } @if (form.get('emailAddress')?.hasError('pattern')) {
         <mat-error> Invalid Email Address </mat-error>
         }
      </mat-form-field>
      @if (accountId) {
      <mat-form-field class="flex-half">
         <mat-label>Location</mat-label>
         <input
            autocomplete="off"
            type="text"
            [lcsSingleSelect]="locationSelect"
            ndtLocationSelect
            [accountId]="accountId"
            [formControl]="parentFormGroup.get('location')"
            id="location"
         />
         <ndt-location-select #locationSelect isIncludeEmptyOption="true"></ndt-location-select>
      </mat-form-field>
      }
      <mat-form-field class="flex-half">
         <mat-label>Time Zone</mat-label>
         <input
            class="empty-option-placeholder"
            [lcsSingleSelect]="timeZoneSelect"
            ndtTimeZoneSelect
            autocomplete="off"
            type="text"
            [formControl]="parentFormGroup.get('timeZone')"
            id="extension-phone-time-zone"
            [placeholder]="
               'Use Location/Account Time Zone - (' +
               (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
               ')'
            "
         />
         <ndt-time-zone-select
            #timeZoneSelect
            isIncludeEmptyOption="true"
            [overrideEmptyOption]="
               'Use Location/Account Time Zone - (' +
               (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
               ')'
            "
         ></ndt-time-zone-select>
      </mat-form-field>
      @if (extensionPrivileges) {
      <ndt-fax-emails
         [form]="form"
         class="flex-full"
         formControlName="faxEmailAddresses"
         [extensionId]="extensionFax?.extension?.extensionId"
         [extensionPrivileges]="extensionPrivileges"
         [isOnAdd]="true"
      >
         ></ndt-fax-emails
      >
      }
   </ng-template>
</div>
